/* Oct 8–9 2026: small wording touches inside the Qikify cart drawer (styling lives in jd-cart-polish.css) */
(()=>{
  let queued=false;
  function polish(){
    queued=false;
    const drawer=document.querySelector('.qsc2-drawer__content');
    if(!drawer)return;
    const title=drawer.querySelector('.qsc2-recommendation-title');
    if(title&&title.dataset.jd!=='1'){title.textContent='You may also love';title.dataset.jd='1';}
    const wrap=drawer.querySelector('.qsc2-gift-wrapping__msg');
    if(wrap&&!wrap.querySelector('.jd-cart-emoji'))wrap.insertAdjacentHTML('afterbegin','<span class="jd-cart-emoji" aria-hidden="true">✨</span> ');
    drawer.querySelectorAll('.qsc2-side-feature-btn').forEach(btn=>{
      if(/gift message/i.test(btn.textContent)&&!btn.querySelector('.jd-cart-emoji'))btn.insertAdjacentHTML('afterbegin','<span class="jd-cart-emoji" aria-hidden="true">💌</span>');
    });
    /* Oct 9 2026: warmer empty cart (Qikify's text and button stay; wording and quick links added) */
    const empty=drawer.querySelector('.qsc2-drawer--empty');
    if(empty){
      const txt=empty.querySelector('.qsc2-drawer--empty-text');
      if(txt&&txt.dataset.jd!=='1'){txt.dataset.jd='1';txt.innerHTML='<span class="jd-empty__title">Your cart is waiting for a new friend</span><span class="jd-empty__sub">Find a doll that feels like home, made with cultural care for everyday play.</span>';}
      const btn=empty.querySelector('.qsc2-btn-empty-state');
      if(btn&&btn.dataset.jd!=='1'){btn.dataset.jd='1';btn.textContent='Start exploring';btn.setAttribute('aria-label','Start exploring');}
      if(!empty.querySelector('.jd-empty__links'))empty.insertAdjacentHTML('beforeend','<nav class="jd-empty__links" aria-label="Popular places to start"><a href="/collections/best-sellers">Best sellers</a><a href="/pages/cultural-collections">Shop by culture</a><a href="/collections/bundles">Bundles</a></nav>');
    }
  }
  new MutationObserver(()=>{if(!queued){queued=true;requestAnimationFrame(polish);}}).observe(document.body,{childList:true,subtree:true});
  polish();
})();
